import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

export interface LiteratureLibraryPageStyles {
    page?: MobiusPageProps;
}

export const literatureLibraryPageStyles: LiteratureLibraryPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

type Props = PageProps;
const styles = literatureLibraryPageStyles;
const LiteratureLibraryPage: React.FC<Props> = ({ id }) => {
    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="LiteratureLibraryPageContent" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: LiteratureLibraryPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "LiteratureLibraryPage" instead of this constant.
 */
export const LiteratureLibraryPageContext = "LiteratureLibraryPage";
